<template>
    <div
        class="entity-item"
        :class="{'head-entity': headNode}"
    >
        <or-collapsible
            class="entity-collapsable"
            v-if="isCollapsible"
            :open="isOpened"
            @open="isOpened = true"
            @close="isOpened = false"
            :removeIcon="true"
        >
            <template #header>
                <div class="name-wrapper">
                    <or-icon
                        class="toggle-icon"
                        :style="{ transform: `rotate(${isOpened ? 0 : -90}deg)` }"
                        icon="arrow_drop_down"
                    />
                    <div class="entity-item--name">
                        {{entityTitle}}
                    </div>
                </div>
                <entity-type-label
                    :entity-type="entity.type"
                />
            </template>
            <div class="entity-body">
                <div class="entity-item--mapped-helptext">{{ $t('model.nlu-model.sidebar.responseinspector.entityitem.mappedTo') }}</div>
                <div class="entity-item--mapped-value">
                    {{entity.value}}
                </div>
                <div class="entity-item--child">
                    <entity-item
                        v-for="child in entity.children"
                        :key="child.id"
                        :entity="child"
                    />
                </div>
            </div>
        </or-collapsible>
        <div v-if="!isCollapsible" class="header">
            <div class="entity-item--name">
                {{entityTitle}}
            </div>
            <entity-type-label
                :entity-type="entity.type"
            />
        </div>
        <div
            v-if="!isOpened"
            class="entity-body"
        >
            <div class="entity-item--mapped-helptext">
              {{ $t('model.nlu-model.sidebar.responseinspector.entityitem.mappedTo') }}
            </div>
            <div class="entity-item--mapped-value">
                {{entity.value}}
            </div>
        </div>
    </div>
</template>

<script>
import EntityTypeLabel from '@/components/model/common/EntityTypeLabel'
import { ENTITY_TYPE } from '@/components/model/nlu-model/sidebar/entities/entity-types'

export default {
  name: 'entity-item',

  components: {
    EntityTypeLabel
  },

  props: {
    headNode: Boolean,
    entity: Object
    // {
    //     type    : String, // ENTITY_TYPE
    //     entity  : String,
    //     startPos: Number,
    //     endPos  : Number,
    //     value   : String,
    //     children: Array // optional, only applicable for ENTITY_TYPE.machineLearning
    // }
  },

  data () {
    return {
      isOpened: false
    }
  },

  computed: {
    entityTitle () {
      let title = this.entity.entity
      if (this.entity.role) {
        title += `:${this.entity.role}`
      }
      return title
    },

    isCollapsible () {
      return this.entity.type === ENTITY_TYPE.machineLearning && this.entity.children.length !== 0
    }
  }
}
</script>

<style lang="scss" scoped>
    .head-entity {
        padding-right: $sp-3;
    }
    .entity-item {
        margin-left: 3px;
        ::v-deep .or-collapsible > .body-wrapper > .body {
            padding-right: 0;
        }
        ::v-deep .header-content {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .entity-item--child {
            padding-left: $sp-4;
            border-left: 1px solid #eaeaea;
        }

        .entity-collapsable {
            margin-left: -$sp-3;
        }

        .toggle-icon {
            margin-right: 2px;
            font-size: 18px;
        }

        .name-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: $sp-1;
            margin-bottom: $sp-3;
        }

        .entity-item--name {
            color: rgb(30, 35, 43);
            font-size: 14px;
            font-weight: 600;
            line-height: 21px;
        }

        .entity-item--mapped-helptext {
            margin-bottom: $sp-2;
            color: rgb(145, 150, 157);
            font-size: 12px;
            letter-spacing: 0;
            line-height: 18px;
        }

        .entity-item--mapped-value {
            margin-bottom: $sp-3;
            color: rgb(30, 35, 43);
            font-size: 14px;
            letter-spacing: -0.15px;
            line-height: 21px;
        }
    }
</style>
